import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { List, ListItemButton, ListItemIcon, ListItemText, Divider, Collapse } from '@mui/material';
import { styled } from '@mui/material/styles';
import DashboardIcon from '@mui/icons-material/Dashboard';
import QuizIcon from '@mui/icons-material/Quiz';
import PeopleIcon from '@mui/icons-material/People';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SettingsIcon from '@mui/icons-material/Settings';
import { AuthContext } from '../../context/AuthContext';

// Styled components
const NavItem = styled(ListItemButton)(({ theme, active }) => ({
  borderRadius: 8,
  marginBottom: 5,
  backgroundColor: active ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  '& .MuiListItemIcon-root': {
    color: active ? theme.palette.primary.main : 'white',
  },
  '& .MuiListItemText-primary': {
    color: 'white',
    fontWeight: active ? 600 : 400,
  },
}));

const Divider1 = styled(Divider)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  margin: '16px 0',
}));

function Sidebar() {
  const location = useLocation();
  const { user } = useContext(AuthContext);
  
  // Check if the current path matches the nav item
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <List component="div" disablePadding>
      {/* Dashboard */}
      <NavItem
        component={Link}
        to="/dashboard"
        active={isActive('/dashboard').toString()}
      >
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </NavItem>
      
      {/* Questions Management */}
      <NavItem
        component={Link}
        to="/questions"
        active={isActive('/questions').toString()}
      >
        <ListItemIcon>
          <QuizIcon />
        </ListItemIcon>
        <ListItemText primary="Questions" />
      </NavItem>
      
      {/* Users Management */}
      {user?.is_admin && (
        <NavItem
          component={Link}
          to="/users"
          active={isActive('/users').toString()}
        >
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Users" />
        </NavItem>
      )}
      
      <Divider1 />
      
      {/* Leaderboard */}
      <NavItem
        component={Link}
        to="/leaderboard"
        active={isActive('/leaderboard').toString()}
      >
        <ListItemIcon>
          <LeaderboardIcon />
        </ListItemIcon>
        <ListItemText primary="Leaderboard" />
      </NavItem>
      
      {/* Winners */}
      <NavItem
        component={Link}
        to="/winners"
        active={isActive('/winners').toString()}
      >
        <ListItemIcon>
          <EmojiEventsIcon />
        </ListItemIcon>
        <ListItemText primary="Winners" />
      </NavItem>
      
      <Divider1 />
      
      {/* Profile/Settings */}
      <NavItem
        component={Link}
        to="/profile"
        active={isActive('/profile').toString()}
      >
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Profile" />
      </NavItem>
    </List>
  );
}

export default Sidebar;